/*
Akhila 29/11/2022 3075220937 Added new component it will render only its calculation only Test
Guru Prasad 11/29/2022 3075220937 Added styles for test popup
Guru Prasad 11/30/2022 3075220937 Added class name for test popup
Akhila 11/30/2022 3075220937 Addded validation on error, result will not display
Dilip 12/05/2022  3075220937 Removed unecesarry console.log statements
Akhila 01/24/2023 3075220937 Fixed Boolean result value bug fixed
*/

import React from 'react';
import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  postTestRuleGroup,
  resetTestResult,
} from '../../../../../../redux/reducers/BRE/AddRuleGroup';
import {Alert} from '@material-ui/lab';
import reusableInputStyles from '../../../../../../components/InputStyles';

const CalculationTestForm = ({formData, result}) => {
  const dispatch = useDispatch();
  const {basicInfoData, testResponse, testErrorMsg} = useSelector(
    ({addRuleGroup}) => addRuleGroup,
  );
  const classes = reusableInputStyles();
  useEffect(() => {
    const passValues = {
      addRule: formData.map((item) => {
        return {
          ruleCode: item?.ruleCode,
          formulaExpression: item?.formulaExpression ? item?.formulaExpression : '',
          ruleId: item?.ruleId || 0,
        };
      }),
      result: result,
      returnType: basicInfoData?.returnType ? basicInfoData.returnType : null,
      formulaType: basicInfoData?.formulaType,
      fieldListCode: '',
      startAccountNo: '',
      limit: null,
      page: 0,
      category: '',
      formulaRuleGroupId:basicInfoData?.groupId ? basicInfoData?.groupId : 0,
    };
    dispatch(resetTestResult());
    dispatch(postTestRuleGroup(passValues));
  }, []);

  return (
    <>
      <div className={classes.dialoguecardStyles}>
        {testErrorMsg && typeof testErrorMsg === 'string' ? (
          <Alert className="mb-2" severity="error">
            {' '}
            {testErrorMsg}{' '}
          </Alert>
        ) : (
          <div className="test-popup">
            <h1 className="diaglobx-heading">Result:</h1>
            <p className="mb-0 content-box">
              {' '}
              {testResponse?.response?.result?.toString() ?
                testResponse?.response?.result?.toString() :
                ''}{' '}
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default CalculationTestForm;
